export const Footer =()=>{
    return(
        <>
            <div className="row  pt-4 pe-3">
                <div className="col-12 border text-center shadow rounded bg-white">
                    <p className=" py-2 px-4 pt-3 rounded">© 2025 Copyright CDAT. All Rights Reserved.</p>
                </div>
            </div>
        </>
    )
}